import { Stack, Typography } from '@mui/material'
import classes from './styles.module.scss'

type Props = {
  title?: string
  subtitle?: string
}

const FooterSetup = ({ title, subtitle }: Props) => {
  return (
    <Stack>
      <Typography className={classes.title}>
        {title}
      </Typography>
      <Typography className={classes.subtitle}>
        {subtitle}
      </Typography>
    </Stack>
  )
}

export default FooterSetup